
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import mentee from "../../assets/new images/mentee.png";
import backgroundImage from "../../assets/new images/contactus.png";
import TeamBioSection from "../../components/root/TeamBioSection";
import ContactSection from "../../components/root/ContactSection";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";

const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/contact-us"]}
        path="/contact-us"
      />

      <Hero bgImage={backgroundImage}
        badgeText=""
        titleLines={[t("contactUs.heroTitle")]}
        subtitle=""
        // primary={{ label: "Find a Mentor", href: "/mentors" }}
        // secondary={{ label: "Try AI Career Coach", href: "/ai-career" }}
        curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
        heightClass="h-[80vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

<ContactSection/>


    </div>
  );
};

export default ContactUs;
